<template>
  <div class="add-input-list-ctr">
    <label
      class="y-form-label y-form-label__heavy"
      :class="is_required ? 'is-required': ''"
    >{{ label }}</label>
    <div v-for="(item, index) in dataList" :key="index" class="y-form-input-list">
      <el-input
        :placeholder="placeholderText"
        class="y-form-input y-form-input__small"
        :class="errors.first(item+index) ? 'y-form-input-error':''"
        style="width:300px"
        v-model="item.value"
        data-vv-validate-on="change"
        :data-vv-name="item+index"
        :data-vv-as="errorMsgLabel"
        v-validate="validationRule"
        @blur="checkDuplicateValue(item+index)"
      >
        <el-link
          class="el-icon-remove-outline"
          slot="suffix"
          @click="removeInputbox(index)"
          v-show="index > 0"
        ></el-link>
      </el-input>
      <span class="y-form-error errorField" v-show="errors.first(item+index)">
        <i class="el-icon-warning"></i>
        {{errors.first(item+index)}}
      </span>
    </div>
    <el-link class="y-form-link" @click="addInputbox()" v-show="dataList.length != maxListCount">
      <i class="el-icon-circle-plus-outline"></i>
      Add up to {{maxListCount - dataList.length}} more
    </el-link>
  </div>
</template>

<script>
export default {
  name: 'yAddInputboxList',
  inject: ['$validator'],
  data() {
    return {
      label: this.data.label ? this.data.label : '',
      errorMsgLabel: this.data.errorMsgLabel ? this.data.errorMsgLabel : '',
      is_required: this.data.is_required,
      dataList: this.data.dataList ? this.data.dataList : [{ value: '' }],
      maxListCount: this.data.maxListCount ? this.data.maxListCount : 5,
      placeholderText: this.data.placeholderText
        ? this.data.placeholderText
        : '',
      validationRule: this.data.validationRule
    }
  },
  mounted() {
    this.$emit('update', this.dataList)
  },
  props: {
    data: Object
  },
  created() {},
  computed: {},
  methods: {
    addInputbox() {
      this.dataList.push({ value: '' })
    },
    removeInputbox(index) {
      this.dataList.splice(index, 1)
    },
    checkDuplicateValue(field) {
      // var obj = {}
      // var list = this.dataList
      // var hasDuplicates = list.some(function(currentObj) {
      //   return (
      //     obj.hasOwnProperty(currentObj.name) || (obj[currentObj.name] = false)
      //   )
      // })
      // if (hasDuplicates) {
      //   let msg = 'Already exists! Please enter a different ' + this.label + '.'
      //   this.errors.add({
      //     field,
      //     msg
      //   })
      // }
    }
  }
}
</script>

<style>
.data-list-cnr {
  margin-top: 0px;
  margin-bottom: 16px;
}

.data-list-cnr .data-list-item {
  padding-left: 12px;
  text-align: left;
  height: 32px;
  margin-bottom: 4px;
  background-color: #f0f0f0;
  border-radius: 4px;
}

.data-list-cnr .data-list-item:last-child {
  margin-bottom: 36px;
}

.data-list-cnr .data-list-item > span {
  vertical-align: middle;
  width: 200px;
  float: left;
  height: 32px;
  line-height: 32px;
}

.data-list-cnr .data-list-item .v-btn__content i {
  font-size: 18px;
  color: #dc3828;
}

.data-list-cnr .data-list-item button {
  margin-left: 16px;
  float: right;
  height: 32px;
}
</style>
